import { render, staticRenderFns } from "./MessageMediaItem.vue?vue&type=template&id=216c01be&scoped=true&"
import script from "./MessageMediaItem.vue?vue&type=script&lang=ts&"
export * from "./MessageMediaItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMediaItem.vue?vue&type=style&index=0&id=216c01be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c01be",
  null
  
)

export default component.exports